export default __webpack_public_path__ + "static/datelabel-dropdown-dont-2-light-f3ad3064eccec9fd38288e83e392706ad8ec9e0cf8ae6dd364af612523f76813.png";